import React, { useEffect, useState } from 'react';
import { Nav, Container, Form, Button, Row, Col} from 'react-bootstrap';
import "./device-section.css";
import Details from './components/Details/details';
import Performance from './components/Performance/performance';
import MostUsedApps from './components/MostUsedApps/most-used-apps';
import OverallExp from './components/OverallExp/overall-exp';


// charts in this section are built using chart.js and react-chartjs-2 libraries
// docs for chart: https://www.chartjs.org/docs/latest/

const DeviceSection: React.FC = () => {

    return (
        <Container>
            <Row >
                <Col lg={8} md={12} style={{padding: 12}}>
                    <Performance />
                </Col>
                <Col lg={4} md={12} style={{padding: 12}}>
                    <Details />
                </Col>
            </Row>
            <Row >
                <Col lg={6} style={{padding: 12}}>
                    <MostUsedApps />
                </Col>
                <Col lg={6} style={{padding: 12}}>
                    <OverallExp />
                </Col>
            </Row>
        </Container>
    )
}

export default DeviceSection;